/* eslint-disable @typescript-eslint/no-explicit-any */
import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import { LenderSummaryHeaderInterface } from 'app/interfaces/lender/LenderSummaryHeaderInterface';
import { PortofolioDetailRequestInterface } from 'app/interfaces/lender/PortofolioDetailInterface';
// import environment from 'environments/environment';
import { IDocumentDownload, IDownloadDocumentRequest } from 'app/interfaces/document-download/document-download.interface';
import apiRequest from '../api/api.request';
import { ApiRequestConfig } from '../../interfaces/api-request/api.interface';
import endpoints from '../../../constants/endpoints';
import {
	downloadFactsheetAction,
	getLenderSummaryHeaderAction,
	getPortofolioDetailAction,
	getPortofolioListAction,
	ILenderSummaryHeaderResponse,
	IPortofolioListResponse,
	IPortofolioParamsRequest,
	resetFactsheetAction,
	setFactsheetAction,
	setLenderSummaryAction,
	setPortofolioDetailAction,
	setPortofolioListAction,
} from '../actions/PortofolioAction';
import {
	IPortofolioListDetail,
	IPortofolioListItem,
} from '../reducers/PortofolioReducer';

function* fetchPortofolioList({
	payload,
}: {
	payload: IPortofolioParamsRequest;
}): Generator {
	const auth = JSON.parse(JSON.stringify(localStorage.getItem('user')));
	const config: ApiRequestConfig = {
		path: endpoints.api.PORTOFOLIO_LIST,
		method: 'GET',
		headers: {
			Authorization: `Bearer ${JSON.parse(auth).token}`,
			"X-Authenticated-Userid": `${JSON.parse(auth).userId}`,
		},
		query: payload,
		body: null,
		timeout: 0,
	};
	try {
		const res = yield call(apiRequest, config);
		const { data, pagination } = res as any;
		const response = {
			portofolioList: data as IPortofolioListItem[],
			pagination,
		};
		yield put(setPortofolioListAction(response));
	} catch (err) {
		// yield put(
		// 	successSetPortofolioList(
		// 		[],
		// 		{ totalData: 0, totalPage: 0 },
		// 		'failed'
		// 	)
		// );
	}
}

function setPortofolioListSaga({
	payload,
}: {
	payload: IPortofolioListResponse;
}): IPortofolioListResponse {
	try {
		return payload;
	} catch (err) {
		return payload;
	}
}

function* fetchLenderSummaryHeaderSaga(): Generator {
	const auth = JSON.parse(JSON.stringify(localStorage.getItem('user')));
	const config: ApiRequestConfig = {
		path: endpoints.api.LENDER_HEADER_SUMMARY,
		method: 'GET',
		headers: {
			Authorization: `Bearer ${JSON.parse(auth).token}`,
			"X-Authenticated-Userid": `${JSON.parse(auth).userId}`,
		},
		query: null,
		body: {},
		timeout: 0,
	};
	try {
		const res = yield call(apiRequest, config);
		const { data } = res as any;
		yield put(setLenderSummaryAction(data as LenderSummaryHeaderInterface));
	} catch (err) {
		// yield put(
		// 	successSetPortofolioList(
		// 		[],
		// 		{ totalData: 0, totalPage: 0 },
		// 		'failed'
		// 	)
		// );
	}
}

function setLenderSummaryHeaderSaga({
	payload,
}: {
	payload: ILenderSummaryHeaderResponse;
}): ILenderSummaryHeaderResponse {
	try {
		// yield put(successSetPortofolioList(payload, 'success'));
		return payload;
	} catch (err) {
		// yield put(
		// 	successSetPortofolioList(
		// 		[],
		// 		{ totalData: 0, totalPage: 0 },
		// 		'failed'
		// 	)
		// );
		return payload;
	}
}

function* fetchPortofolioDetailSaga({
	payload,
}: {
	payload: PortofolioDetailRequestInterface;
}): Generator {
	const auth = JSON.parse(JSON.stringify(localStorage.getItem('user')));
	const config: ApiRequestConfig = {
		path: endpoints.api.PORTOFOLIO_DETAIL,
		method: 'GET',
		headers: {
			Authorization: `Bearer ${JSON.parse(auth).token}`,
		},
		query: payload,
		body: null,
		timeout: 0,
	};
	try {
		const res = yield call(apiRequest, config);
		const { data, pagination } = res as any;
		const result = {
			detailList: data,
			propertyLenderId: payload.propertyLenderId,
			pagination,
		};
		yield put(setPortofolioDetailAction(result));
	} catch (err) {
		// yield put(
		// 	successSetPortofolioList(
		// 		[],
		// 		{ totalData: 0, totalPage: 0 },
		// 		'failed'
		// 	)
		// );
	}
}

function setPortofolioDetailSaga({
	payload,
}: {
	payload: IPortofolioListDetail;
}): IPortofolioListDetail | unknown {
	try {
		return payload;
	} catch (err) {
		// yield put(
		// 	successSetPortofolioList(
		// 		[],
		// 		{ totalData: 0, totalPage: 0 },
		// 		'failed'
		// 	)
		// );
		return payload;
	}
}

function setFactsheetSaga({
	payload,
}: {
	payload: IDocumentDownload;
}): IDocumentDownload {
	try {
		return payload;
	} catch (err) {
		return payload;
	}
}

function* downloadDocumentSaga({
	payload,
}: {
	payload: IDownloadDocumentRequest
}): Generator {
	const userData = localStorage.getItem('user');
	let userToken = "";
	if (userData) {
		const resp = JSON.parse(userData);
		userToken = resp.token;
	}
	// const auth = `${environment.authUsername}:${environment.authPassword}`;
	const config: ApiRequestConfig = {
		path: endpoints.api.DOWNLOAD_DOCUMENT,
		method: 'POST',
		headers: {
			Authorization: `Bearer ${userToken}`,
		},
		query: null,
		body: payload,
		timeout: 0,
		responseType: 'arraybuffer', // ini adalah kunci
	};
	try {
		const resp = yield call(apiRequest, config);

		let type = 'image/*';
		if (payload.document_url.includes('.pdf')) {
			type = 'application/pdf';
		}

		const blobResult = new Blob([new Uint8Array(resp as any)], { type });

		yield put(setFactsheetAction({ base64Image: blobResult }));
	} catch (err) {
		// return payload;
	}
}

function resetFactsheetSaga({
	payload,
}: {
	payload;
}): IDocumentDownload {
	try {
		return payload;
	} catch (err) {
		return payload;
	}
}

export default function* portofolioSaga(): Generator {
	yield takeLatest(
		getLenderSummaryHeaderAction,
		fetchLenderSummaryHeaderSaga
	);
	yield takeEvery(setLenderSummaryAction, setLenderSummaryHeaderSaga);
	yield takeLatest(getPortofolioListAction, fetchPortofolioList);
	yield takeEvery(setPortofolioListAction, setPortofolioListSaga);
	yield takeLatest(getPortofolioDetailAction, fetchPortofolioDetailSaga);
	yield takeEvery(setPortofolioDetailAction, setPortofolioDetailSaga);
	yield takeLatest(downloadFactsheetAction, downloadDocumentSaga);
	yield takeLatest(setFactsheetAction, setFactsheetSaga);
	yield takeLatest(resetFactsheetAction, resetFactsheetSaga);
}
